import request from '@/api/request';

const monitorRequest = request(process.env.VUE_APP_MONITOR_API);

export function GetCommandByImei (params) {
  return monitorRequest({
    url: 'send-commands/get-by-imei',
    method: 'get',
    params
  });
}

export function SendCommandToDevice (data) {
  return monitorRequest({
    url: 'send-commands',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/monitor.js